import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const NoesisV2 = model.views(views);

export interface INoesisStore extends Instance<typeof NoesisV2> {}

export default NoesisV2;
